import React, { useEffect, useState } from 'react';

interface CountdownTimerProps {
  expiresAt: string;
}

// แยก component เพื่อไม่ให้ re-render ทั้งหน้าทุก 1 วินาที
const CountdownTimer: React.FC<CountdownTimerProps> = React.memo(({ expiresAt }) => {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    const update = () => {
      const diff = new Date(expiresAt).getTime() - Date.now();
      if (diff <= 0) { setTimeLeft('00:00'); return false; }
      // ≥ 1 ชม. แสดง h:mm:ss (setting อายุ slip order ตั้งได้ถึง 180 นาที)
      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      const mmss = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      setTimeLeft(hours > 0 ? `${hours}:${mmss}` : mmss);
      return true;
    };
    if (!update()) return;
    const timer = setInterval(() => { if (!update()) clearInterval(timer); }, 1000);
    return () => clearInterval(timer);
  }, [expiresAt]);

  return <>{timeLeft}</>;
});

export default CountdownTimer;
